import { EventEmitter } from 'events';

const progressEvent = new EventEmitter();
const progressHandle = (id, { percent, message, type, auto, maxAutoPercent }) => {
  try {
    if (progressEvent.listenerCount(id) > 0) {
      progressEvent.emit(id, { percent, message, type, auto, maxAutoPercent })
    }
  } catch (e) { }
};

export {
  progressEvent,
  progressHandle
}